$(document).ready(function () {


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * teleport links
    // *
    // * @set outer parent element class: js-href-teleport-wrapper
    // * @set link (<a> tag) element class: js-href-teleport-link
    // * @set element to add the link to class: js-href-teleport
    // *
    // * This adds a link tag (<a>) to other elements within a wrapper
    // * links comes from a link. Example: add a link to h2, image etc. inside a teaser
    // *
    $(".js-href-teleport").each(function () {
        var $link = $(this).parents(".js-href-teleport-wrapper").find(".js-href-teleport-link"),
            href = $link.attr("href"),
            target = $link.attr("target") ? $link.attr("target") : '_self';

        if (href) {
            $(this).wrapInner('<a href="' + href + '" target="' + target + '"></a>');
        }
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * parent clickable elements (excludes links inside)
    // *
    // * @set outer parent element class: js-click-item-parent
    // * @set link (<a> tag) element class: js-click-item-link
    // *
    // * This makes the whole element clickable and still
    // * makes other links inside clickable with their target
    // *
    $(".js-click-item-parent").delegate('a', 'click', function (e) {
        var target = $(this).attr("target"),
            url = $(this).attr("href");

        if (target == "_blank") {
            window.open(url);
        } else {
            window.location = url;
        }
        return false;
    }).click(function () {
        var target = $(this).find("a.js-click-item-link").attr("target"),
            url = $(this).find("a.js-click-item-link").attr("href");

        if (target == "_blank") {
            window.open(url);
        } else {
            window.location = url;
        }
        return false;
    });




    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * animateIn
    // *
    // *
    var offset = 80; // Distance from Browserbottom & -top where the animation should start

    function fadeInElements() {
        var viewPortStart = $(window).scrollTop(),
            viewPortEnd = viewPortStart + $(window).height();


        $(".animateIn:visible").each(function () {
            var elementTop = $(this).offset().top,
                elementBottom = $(this).offset().top + $(this).outerHeight();

            if ((elementTop + offset) <= viewPortEnd && (elementBottom - offset) >= viewPortStart) {
                var delay = $(this).data("animation-delay");
                $(this).css("transition-delay", delay + "s").addClass("animateIn--active");
            } else {
                $(this).removeClass("animateIn--active");
            }
        });
    }

    $(window).scroll(function () {
        fadeInElements();
    });

    fadeInElements();


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * add target blank to external links
    // *
    // *
    $('a:not([data-targetblank=ignore])').each(function () {
        if (location.hostname === this.hostname || !this.hostname.length) {
            // ... do nothing?
        } else {
            $(this).attr('target', '_blank');
        }
    });


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * navButton
    // *
    // *
    $(".js-navbutton").click(function () {
        $(this).toggleClass("active");
        $(".js-navmobile").toggleClass("active");
        $("html").toggleClass("freeze")
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * sliderBanner
    // *
    // *
    var $sliderBanner = $(".js-sliderbanner");

    if ($sliderBanner.length) {
        $sliderBanner.each(function () {
            $(this).find(".js-sliderbanner-cards").slick({
                fade: false,
                infinite: true,
                arrows: false,
                autoplay: true,
                autoplaySpeed: 3000,
                speed: 800,
                waitForAnimate: false,
                dots: true,
                pauseOnHover: false,
                appendDots: $(this).find(".js-paging-dots"),
                touchThreshold: 15,
                responsive: [
                    {
                        breakpoint: 700,
                        settings: {
                            speed: 400,
                            swipeToSlide: true
                        }
                    }
                ]
            });
        });
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * sliderCard
    // *
    // *
    var $sliderCard = $(".js-slidercard");

    if ($sliderCard.length) {
        $sliderCard.each(function () {
            $(this).find(".js-slidercard-cards").slick({
                fade: false,
                infinite: true,
                arrows: true,
                autoplay: false,
                autoplaySpeed: 2000,
                speed: 800,
                waitForAnimate: false,
                dots: true,
                pauseOnHover: false,
                slidesToShow: 3,
                slidesToScroll: 3,
                appendDots: $(this).find(".js-paging-dots"),
                prevArrow: $(this).find(".js-paging-prev"),
                nextArrow: $(this).find(".js-paging-next"),
                touchThreshold: 15,
                responsive: [
                    {
                        breakpoint: 1300,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        }
                    },
                    {
                        breakpoint: 700,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            speed: 400,
                            swipeToSlide: true
                        }
                    }
                ]
            });
        });
    }
    
    


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * heroSlider
    // *
    // *
    var $heroSlider = $(".js-hero-slider");

    if ($heroSlider.length) {
        $heroSlider.each(function () {
            $(this).find(".js-hero-slider-track").slick({
                fade: false,
                infinite: true,
                arrows: true,
                autoplay: true,
                autoplaySpeed: 2500,
                speed: 1000,
                waitForAnimate: true,
                dots: true,
                pauseOnHover: false,
                appendDots: $(this).find(".js-hero-slider-dots"),
                prevArrow: $(this).find(".js-hero-slider-prev"),
                nextArrow: $(this).find(".js-hero-slider-next"),
            });
            $(this).on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
                var i = (currentSlide ? currentSlide : 0) + 1;
                $(this).find(".js-hero-slider-count").text(i);
            });
        });
    }


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * form files
    // *
    // *
    $('#btn-dokumente').on('click', function(e) {
        e.preventDefault();
        $('#dokumente').trigger('click');
    });

    // Wenn sich der Wert des File-Inputs ändert (Dateien wurden ausgewählt)
    $('#dokumente').on('change', function() {
        var fileListContainer = $('#dokumente-liste');
        fileListContainer.empty(); // Vorherige Einträge löschen

        var files = $(this)[0].files;
        
        if (files.length > 0) {
            var listHtml = '<ul class="form__file-ul">';
            for (var i = 0; i < files.length; i++) {
                listHtml += '<li class="form__file-li">' + files[i].name + '</li>';
            }
            listHtml += '</ul>';
            fileListContainer.html(listHtml);
        } else {
            fileListContainer.html('<p class="form__file-empty">Keine Datei ausgewählt</p>');
        }
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * contentSlider
    // *
    // *
    var $contentSlider = $(".js-content-slider");

    if ($contentSlider.length) {
        $contentSlider.each(function () {
            $(this).find(".js-content-slider-track").slick({
                fade: false,
                infinite: true,
                arrows: true,
                autoplay: true,
                autoplaySpeed: 2500,
                speed: 1000,
                waitForAnimate: true,
                dots: true,
                pauseOnHover: false,
                appendDots: $(this).find(".js-content-slider-dots"),
                prevArrow: $(this).find(".js-content-slider-prev"),
                nextArrow: $(this).find(".js-content-slider-next"),
            });

            $(this).on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
                var i = (currentSlide ? currentSlide : 0) + 1;
                $(this).find(".js-content-slider-count").text(i);
            });
        });
    }

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * accordion
    // *
    // *
    $(".js-accordion-button").click(function () {
        // Toggle the aria-expanded attribute for the current accordion item
        const $content = $(this).siblings(".js-accordion-content");
        const isExpanded = $content.attr("aria-expanded") === "true";
        $content.attr("aria-expanded", !isExpanded);

        // Close other accordion items
        $(this).parents(".js-accordion-wrapper")
            .find(".js-accordion-content")
            .not($content)
            .attr("aria-expanded", "false");

        setTimeout(() => {
            $(this)[0].scrollIntoView({ behavior: 'smooth' });
        }, 400);
    });

    function openAccordionFromHash() {
        let hash = window.location.hash.split('#')[1];
        if (hash && $("#" + hash).hasClass("js-accordion-button") && $("#" + hash).siblings(".js-accordion-content").attr("aria-expanded") !== "true") {
            $("#" + hash).click();
        }
    }

    // open acoordion on load
    openAccordionFromHash();

    // open accordion from same page
    $(window).on('hashchange', function () {
        openAccordionFromHash();
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    // * dialog window
    // *
    // *
    var $dialog = $(".js-dialog"),
        dialogState = sessionStorage.getItem('dialogState');

    $(".js-close-dialog").click(function () {
        $dialog.addClass("close");
        sessionStorage.setItem('dialogState', true);
        $(this).parents(".js-dialog").get(0).close();
        $("body").removeClass("freeze");
    });

    // backdrop click
    $(".js-dialog").click(function (e) {
        if (e.target === e.currentTarget) {
            $dialog.addClass("close");
            sessionStorage.setItem('dialogState', true);
            $(this).get(0).close();
            $("body").removeClass("freeze");
        }
    });

    if (!dialogState && $dialog.length > 0) {
        $dialog.get(0).showModal();
        $("body").addClass("freeze");
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
    // * filter cars
    // *
    // *
    const mixitupModules = document.querySelectorAll('.js-mixitup-module');

    mixitupModules.forEach(module => {
        const container = module.querySelector('.js-mixitup-container');
        const sortSelect = module.querySelector('.js-mixitup-sort');
        const countElement = module.querySelector('.js-mixitup-count'); // Neues Element für die Zählung

        if (container && sortSelect && typeof mixitup !== 'undefined') {

            console.log("works");
            
            // Verhindert ein kurzes Aufblitzen der "0", bevor MixItUp lädt
            if (countElement) {
                countElement.textContent = container.querySelectorAll('.mix').length;
            }

            // MixItUp instanziieren
            const mixer = mixitup(container, {
                animation: {
                    duration: 300
                },
                render: {
                    target: 'flex' // Zwingend notwendig, da .teaserProduct ein Flex-Container ist
                },
                load: {
                    // Standard-Sortierung beim Laden definieren
                    sort: 'default:asc' 
                },
                callbacks: {
                    // Wird jedes Mal gefeuert, wenn MixItUp sortiert oder filtert
                    onMixEnd: function(state) {
                        if (countElement) {
                            // state.totalShow enthält die Anzahl der aktuell sichtbaren Elemente
                            countElement.textContent = state.totalShow;
                        }
                    }
                }
            });

            // Event Listener für das Native Select Dropdown
            sortSelect.addEventListener('change', (e) => {
                const sortCommand = e.target.value; 
                // sortCommand ist z.B. "price:asc", was MixItUp exakt so versteht, 
                // sofern data-price im HTML vorhanden ist.
                mixer.sort(sortCommand);
            });
        }
    });




});



// * * * * * * * * * * * * * * * * * * * * * * * * *
// * sticky Header
// *
// *
$(window).on("load scroll", function () {
    if ($(window).scrollTop() >= 40) {
        $(".js-header").addClass("sticky");
    } else {
        $(".js-header").removeClass("sticky");
    }
});
